var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 19.25L9.25 23L8 24.25H18L16.75 23L15.8125 19.25M1.75 14.25H24.25M4.25 19.25H21.75C22.413 19.25 23.0489 18.9866 23.5178 18.5178C23.9866 18.0489 24.25 17.413 24.25 16.75V4.25C24.25 3.58696 23.9866 2.95107 23.5178 2.48223C23.0489 2.01339 22.413 1.75 21.75 1.75H4.25C3.58696 1.75 2.95107 2.01339 2.48223 2.48223C2.01339 2.95107 1.75 3.58696 1.75 4.25V16.75C1.75 17.413 2.01339 18.0489 2.48223 18.5178C2.95107 18.9866 3.58696 19.25 4.25 19.25Z",
    stroke: "url(#paint0_linear_11040_67534)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11040_67534",
    x1: 1.75,
    y1: 1.75,
    x2: 24.25,
    y2: 24.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267857,
    stopColor: "#66AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508929,
    stopColor: "#84B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758929,
    stopColor: "#9CB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.2cfda2b2b3c8fa95ab69fbea097bf416.svg";
export { ForwardRef as ReactComponent };